import { render, staticRenderFns } from "./VAccordion.vue?vue&type=template&id=23d7988a&"
import script from "./VAccordion.vue?vue&type=script&lang=js&"
export * from "./VAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports